import { render, staticRenderFns } from "./DeleteCommunityPayment.vue?vue&type=template&id=36c17c8a&scoped=true"
import script from "./DeleteCommunityPayment.vue?vue&type=script&lang=js"
export * from "./DeleteCommunityPayment.vue?vue&type=script&lang=js"
import style0 from "./DeleteCommunityPayment.vue?vue&type=style&index=0&id=36c17c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c17c8a",
  null
  
)

export default component.exports